import { Rack } from 'app/modules/inventory/racks/core/type';
import { Ward } from 'app/modules/system-settings/locations/wards/core/type';

import { QtyUnitsEnum, StockTypeEnum, WeightUnitsEnum } from './enum';
import { LocationFilterParams, QtyUnit, StockType, WeightUnit } from './type';

export const STOCK_TYPE: StockType[] = [
  {
    value: StockTypeEnum['Non-Chargeable'],
    title: StockTypeEnum[0],
  },
  // {
  //   value: StockTypeEnum.Chargeable,
  //   title: StockTypeEnum[1],
  // },
];

export const QTY_UNITS: QtyUnit[] = [
  {
    value: QtyUnitsEnum.Piece,
    title: QtyUnitsEnum[0],
  },
  {
    value: QtyUnitsEnum.Set,
    title: QtyUnitsEnum[1],
  },
  {
    value: QtyUnitsEnum.Box,
    title: QtyUnitsEnum[2],
  },
];
export const WEIGHT_UNITS: WeightUnit[] = [
  {
    value: WeightUnitsEnum.g,
    title: WeightUnitsEnum[0],
  },
];

export enum StatusItem {
  Active = 1,
  Inactive = 2,
}

export const MIN_WEIGHT = 0.001;
export const MAX_WEIGHT = 5000;
export const DECIMAL_REGEX = /^\d+(\.\d{1,4})?$/;

export const DEFAULT_LOCATION_FILTER: LocationFilterParams = {
  locationIds: [],
  rackIds: [],
  page: 1,
};

export const LOCATION_OPTIONS = (locations: Ward[]) =>
  locations.map((location) => ({
    ...location,
    label: location.name,
    value: String(location.id),
  }));

export const SELECTED_LOCATION = (locationIds: string[], locations: Ward[]) =>
  locationIds.map((el) => {
    const location = locations.find((o) => String(o.id) === el);

    return {
      value: el,
      label: location ? location.name : '',
    };
  });

export const RACK_OPTIONS = (racks: Rack[]) =>
  racks.map((rack) => ({
    ...rack,
    label: rack.name,
    value: String(rack.id),
  }));

export const SELECTED_RACK = (rackIds: string[], racks: Rack[]) =>
  rackIds.map((el) => {
    const rack = racks.find((o) => String(o.id) === el);

    return {
      value: el,
      label: rack ? rack.name : '',
    };
  });
